import { cn } from "@/lib/utils";
import { ChevronRight } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function ButtonOutline({
  name,
  path,
  solid = false,
  className,
}: {
  name: string;
  path: string;
  solid?: boolean;
  className?: string;
}) {
  const nav = useNavigate();

  const onClick = () => {
    if (path.startsWith("http")) window.open(path, "_blank");
    else nav(path);
  };

  return (
    <button
      className={cn(
        "text-sm flex gap-2  hover:border-zinc-50/50 items-center p-4 px-5",
        solid
          ? "bg-zinc-50 text-zinc-900"
          : "text-zinc-50 border border-border ",
        className
      )}
      onClick={onClick}
    >
      {name} <ChevronRight size={12} />
    </button>
  );
}
